"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EOfferApplicationHistoryItemType = void 0;
var EOfferApplicationHistoryItemType;
(function (EOfferApplicationHistoryItemType) {
    EOfferApplicationHistoryItemType["STANDARD_NOTE"] = "STANDARD_NOTE";
    EOfferApplicationHistoryItemType["INTERVIEW"] = "INTERVIEW";
    EOfferApplicationHistoryItemType["MESSAGE"] = "MESSAGE";
})(EOfferApplicationHistoryItemType || (exports.EOfferApplicationHistoryItemType = EOfferApplicationHistoryItemType = {}));
